<template>
  <div
    class="flex flex-col items-center justify-between gap-12 pt-20 lg:flex-row"
  >
    <FooterCompanyDisclaimer />
    <AppStoreButtons campaign="footer" tracking-zone="front_office_footer" />
  </div>
</template>

<script setup lang="ts">
import AppStoreButtons from '@backmarket/nuxt-layer-base/components/AppStoreButtons/AppStoreButtons.vue'

import FooterCompanyDisclaimer from '~/scopes/navigation/components/Footer/FooterCompanyDisclaimer.vue'
</script>
